<template>
    <el-dialog center :custom-class="'two-list-dialog'" :visible.sync="dialogVisible" width="1280px" top="16px"
        :show-close="false">
        <div slot="title" style="display: none;">123</div>
        <div class="two-list-container">
            <!-- 左侧列表 -->
            <div class="list-panel left-panel">
                <h3>目标班级</h3>
                <el-card>
                    <ListSearchbar :searchItemsIn="searchItems" @search="handleLeftSearch" />
                    <el-table highlight-current-row @current-change="handleLeftItemClick" :data="leftList">
                        <el-table-column prop="ClassID" label="课程编号"></el-table-column>
                        <el-table-column prop="Name" label="课程名称" width="210"></el-table-column>
                        <el-table-column prop="NianJie" label="年届/学期" width="100">
                            <template slot-scope="scope">
                                <span>{{
                                    scope.row.NianJie +
                                    '/' +
                                    ['', '春', '暑', '秋', '寒'][Number(scope.row.Term)]
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Grade" label="年级/科目" width="140">
                            <template slot-scope="scope">
                                {{ filtName('Grade', scope?.row?.Grade) +
                                    '/' +
                                    filtCourseName(scope.row?.Course) }}
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="ClassModel" label="班型" width="100">
                        <template slot-scope="scope">
                            {{
                                filtName('ClassModel', scope.row.ClassModel)
                            }}
                        </template>
                        </el-table-column>
                        <el-table-column prop="OnlineForm" label="课堂类型">
                            <template slot-scope="scope">
                                <span>{{
                                    scope.row.OnlineForm == 2 ? '双师课' : scope.row.OnlineForm == 1 ? '小班课' :
                                        scope.row.OnlineForm == 3 ? '超大班课' : '大班课'
                                }}</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="TeacherName" label="任课老师"></el-table-column>
                    </el-table>

                </el-card>
            </div>

            <!-- 右侧列表 -->
            <div class="list-panel right-panel">
                <h3>目标讲次</h3>
                <!-- 搜索框 (仅在有数据时启用) -->
                <el-card>
                    <el-table v-loading="loadingRight" @current-change="handleRightItemClick" highlight-current-row
                        :data="rightList" style="max-height: 543px; overflow: auto;">
                        <el-table-column type="index" prop="Name" label="讲次顺序" width="120"></el-table-column>
                        <el-table-column prop="Name" label="讲次名称"></el-table-column>
                        <el-table-column prop="BeginTime" label="上课时间">
                            <template slot-scope="scope">
                                {{ scope?.row?.BeginTime.slice(0, 16) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>

            </div>
        </div>
        <div slot="footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'TwoListSearch',
    props: {
        searchItems: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            searchParams: { "PageSize": 5, "PageIndex": 0, "ClassKeyWord": "", "ClassYear": "", "ClassTerm": "", "ClassCourse": "", "ClassModel": "", "ClassGrade": "" },
            // 左侧列表数据
            leftList: [],
            relatedSelected: null,
            selectedRightItem: null, // 当前选中的右侧项目
            // 右侧列表相关
            selectedLeftItem: null, // 当前选中的左侧项目
            rightList: [],         // 原始右侧数据
            loadingRight: false,    // 加载状态
            dialogVisible: false,
        };
    },

    computed: {
        ...mapGetters(['getUserInfo', 'getBaseMapData']),
    },
    created() {
        this.getClassList()
    },
    methods: {
          ...mapActions(['storeOneClass']),
        // 提交
        async submit() {
            if (!this.selectedLeftItem || !this.selectedRightItem ) {

                this.$message.error('请选择班级和讲次');
                return;
            }
            const selectedData = {
              TargetClassID: this.selectedLeftItem.ClassID,
                TargetLessonID: this.selectedRightItem.ID,
                SrcClassID: this.relatedSelected.ClassID,
               SrcLessonID: this.relatedSelected.ID
            }
            console.log(selectedData)
            try {
                await this.$api.CopyVideo(selectedData)
                  this.$message.success('复制成功');
                  this.dialogVisible = false;
                
                  // 区分是直播还是录播课
                  console.log(this.selectedLeftItem)
                  if (this.selectedLeftItem.listType == 'live') {
                      sessionStorage.setItem('OnlineForm', this.selectedLeftItem.OnlineForm)
                     this.storeOneClass( this.selectedLeftItem)
                      this.$router.push({
                          path: '/liveClassTimesManage',
                          query: {
                              classId: this.selectedLeftItem.ClassID
                          }     
                      })
                  } else {
                      this.$router.push({
                          path: '/videoManage',
                          query: { ClassID: this.selectedRightItem.ClassID, LessonID: this.selectedRightItem.ID,IsSimpleAES: this.selectedRightItem.IsSimpleAES }
                      })
                  }
            } catch (error) {
                this.$message.error(error.message || '提交失败');
            }
        },
        filtCourseName(Course) {
            let arr = this.getBaseMapData.CourseInfo.filter(
                (item) => Course == item.CourseID,
            )
            return arr.length > 0 ? arr[0].CourseName : Course;
        },
        filtName(key, val) {
            let arr = this.getBaseMapData[key + 'Info'].filter(
                (item) => val == item[key + 'ID'],
            )
            return arr.length > 0 ? arr[0][key + 'Name'] : val;
        },
        // 获取直播录播课的班级列表
        async getClassList() {
            try {
                const { ClassInfo } = await this.$api.getListClass(this.searchParams)
                const  res = await this.$api.ListLiveClass(this.searchParams)
                const liveList = res.ClassInfo.map(item => {
                    return {
                        ...item,
                        listType: 'live'
                    }
                })
                const videoList = ClassInfo.map(item => {
                    return{
                        ...item,
                        listType: 'video'
                    }
                })
                console.log(liveList, videoList)
                this.leftList = [...videoList, ...liveList];
            } catch (error) {
                this.$message.error(error.message || '获取班级列表失败');
            }

        },
        // 打开弹窗
        openDialog(val) {
            console.log(this.searchItems)
            this.selectedLeftItem = null;
            this.selectedRightItem = null;
            this.dialogVisible = true;
            this.relatedSelected = val
        },
        // 处理左侧搜索
        handleLeftSearch(val) {
            // 搜索逻辑已在 computed 中处理
            console.log('左侧搜索:', val);
            this.searchParams = { ...this.searchParams, ...val }
            this.getClassList()
        },

        // 处理左侧项目点击
        handleLeftItemClick(item) {
            console.log('左侧点击:', item);
            this.selectedLeftItem = item;
            this.selectedRightItem = ''; // 清空右侧搜索
            this.fetchRightList(item.ClassID); // 根据点击的项目ID获取右侧数据
        },
        // 处理左侧项目点击
        handleRightItemClick(item) {
            console.log('左侧点击:', item);
            this.selectedRightItem = item;
        },


        // 获取右侧列表数据
        async fetchRightList(ClassID) {
            this.loadingRight = true;
            try {
                const { LessonInfo } = await this.$api.liveListLesson({ "PageSize": 100, "PageIndex": 0, "ClassID": ClassID })
                this.rightList = LessonInfo;
            } catch (error) {
                this.$message.error(error.message || '获取讲次列表失败');
            }
            this.loadingRight = false;
        },
    }
};
</script>

<style scoped>
.two-list-container {
    display: flex;
    gap: 12px;
}

.list-panel {
    flex: 1;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}

.left-panel {
    flex: 4;
}

.right-panel {
    flex: 3;
}


.list-panel h3 {
    margin: 0;
    padding: 15px;
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px solid #ebeef5;
    background-color: #f5f7fa;
}

.box-card {
    height: calc(100% - 80px);
    /* 减去标题和搜索框的高度 */
    overflow-y: auto;
    padding: 10px;
}

.list-item {
    margin-bottom: 8px;
}

.list-item:last-child {
    margin-bottom: 0;
}

.loading-text,
.no-data-text {
    text-align: center;
    color: #909399;
    font-size: 14px;
    padding: 20px 0;
}

/* 可选：添加一些滚动条样式 */
.box-card::-webkit-scrollbar {
    width: 6px;
}

.box-card::-webkit-scrollbar-thumb {
    background-color: #c0c4cc;
    border-radius: 3px;
}

.box-card::-webkit-scrollbar-track {
    background-color: #f1f1f1;
}
</style>